<template>
  <material-card v-if="$store.state.menu.Activations" class="card-tabs" color="#004D40">
    <v-flex slot="header">
      <v-tabs v-model="tabs" color="transparent" slider-color="white">
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-package-variant-closed</v-icon>Дилеры
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-format-list-checkbox</v-icon>Покупатели
        </v-tab>
      </v-tabs>
    </v-flex>
    <v-tabs-items>
      <v-tab-item>
        <div class="tab-products">
          <ActivationsDealer v-if="tabs===0" />
          <ActivationsClient v-else-if="tabs===1" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </material-card>
</template>
<script>
import ActivationsDealer from "../components/core/Activations/ActivationsDealer";
import ActivationsClient from "../components/core/Activations/ActivationsClient";

export default {
  components: {
    ActivationsDealer,
    ActivationsClient
  },
  data() {
    return {
      tabs: -1
    };
  },
  methods: {},
  mounted() {
    this.tabs = 0;
  },
  computed: {}
};
</script>

<style>
.tab-products {
  min-height: 70vh;
}
</style>